var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnapshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    stroke: "#545454",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 2h-2A1.333 1.333 0 0 0 2 3.333v2m12 0v-2A1.334 1.334 0 0 0 12.667 2h-2m0 12h2A1.334 1.334 0 0 0 14 12.667v-2m-12 0v2A1.333 1.333 0 0 0 3.333 14h2M10.667 8H5.333m5.334 2.666H5.333m1.334-5.333H5.333",
    stroke: "{stroke}",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapshot);
export default __webpack_public_path__ + "static/media/snapshot.efe109e18a335f39d02052e46395eb2c.svg";
export { ForwardRef as ReactComponent };